import { Button, Flex, Icon, Space, Spinner, Text } from '@tonic-one/react';
import { FilePdfOIcon } from '@tonic-one/react-icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DashboardApi } from 'src/apis';

import config from '../../../../config';
import { useOrgStore } from '@Models/useOrgModel';
import { useUtcOffsetStore } from '@Models/useUtcOffsetModel';
import { reportPendo } from '@Utils/setupPendo';
import { usePermissionStore } from '@Models/usePermissionModel';
import { PermissionNameEnum } from '@Types/permissions';
import { useDashboardServicesStore } from '@Models/useDashboardServicesModel';
import { globalStoreGetter } from '@Utils/globalStoreGetter';
import { DashboardPeriod } from '@Types/dashboard';

const PDFReport = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const utcModel = useUtcOffsetStore();
  const { orgId } = useOrgStore();
  const servicesModel = useDashboardServicesStore();
  const { widthEditablePermission } = usePermissionStore();
  const { t } = useTranslation();

  const downloadRepost = async () => {
    reportPendo('Dashboard.Export.Dashboard.Data.Click', {});
    setLoading(true);
    const dashboardTimeRanges = JSON.parse(
      localStorage.getItem('casDashboardDays') || '{}'
    );
    const {
      OverallThreatDetection = '24h',
      DashboardBec = '24h',
      DashboardDlp = '24h',
      DashboardRansomware = '24h',
      DashboardSecurityRisk = '24h',
      DashboardSummary = '24h',
      DashboardVirtualAnalyzer = '24h',
      DashboardScam = '24h',
      DashboardQuishing = '24h',
    } = dashboardTimeRanges as { [k: string]: DashboardPeriod };
    const casWidgetCategory = localStorage.getItem('casWidgetCategory') || '';
    const dashboardWidgetShow = casWidgetCategory
      ? JSON.parse(casWidgetCategory)
      : config.ui.widgetCategoryShowConfig;
    const params = {
      i18nextLng: localStorage.getItem('i18nextLng') || 'en',
      casUtcOffset: utcModel.offset,
      casUtcOffsetId: utcModel.offsetId,
      casCurSelectedServices: servicesModel.enabledServices,
      casDashboardDays: {
        OverallThreatDetection,
        DashboardBec,
        DashboardDlp,
        DashboardRansomware,
        DashboardSecurityRisk,
        DashboardSummary,
        DashboardVirtualAnalyzer,
        DashboardScam,
        DashboardQuishing,
      },
      casCurSelectedOrgId: orgId,
      casWidgetCategory: dashboardWidgetShow,
      isBlackMode: localStorage.getItem('isBlackMode') || 'true',
    };
    try {
      if (
        !params.casCurSelectedServices ||
        params.casCurSelectedServices.length < 1
      ) {
        window.showNotification({
          titleMsg: t(
            'dashboard.threatDetection.export.notSelectService.failTitle'
          ),
          bodyMsg: t(
            'dashboard.threatDetection.export.notSelectService.failBody'
          ),
          severity: 'error',
        });
      } else {
        await DashboardApi.downloadDashboardReport(params);
        window.showNotification({
          titleMsg: t('dashboard.threatDetection.export.successTitle'),
          bodyMsg: t('dashboard.threatDetection.export.successBody'),
          severity: 'success',
        });
      }
    } catch (e: any) {
      if (
        e.data?.error?.details?.[0]?.code === 'REPORT;DASHBOARD_OUT_OF_LIMIT'
      ) {
        const limitation = e.data?.error?.details?.[0]?.limit || 20;
        window.showNotification({
          titleMsg: t('dashboard.threatDetection.export.failTitle'),
          bodyMsg: t('errors.REPORT;DASHBOARD_OUT_OF_LIMIT', {
            orgName: globalStoreGetter.getOrgsMap().get(orgId),
            limitation,
          }),
          severity: 'error',
        });
      } else if (e.status && e.status === 429) {
        window.showNotification({
          titleMsg: t('dashboard.threatDetection.export.failTitle'),
          bodyMsg: t('dashboard.threatDetection.export.failBody'),
          severity: 'error',
        });
      } else {
        window.showNotification({
          titleMsg: t('dashboard.threatDetection.export.errorTitle'),
          bodyMsg: t('dashboard.threatDetection.export.errorBody'),
          severity: 'error',
        });
      }
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Flex align="center">
      <Button
        data-track={`Dashboard.PDFReport`}
        variant="secondary"
        onClick={downloadRepost}
        disabled={
          loading || !widthEditablePermission(PermissionNameEnum.dashboard)
            ? true
            : false
        }
        _disabled={{
          cursor: 'not-allowed',
        }}
      >
        {loading ? <Spinner size="xs" /> : <Icon as={FilePdfOIcon} />}
        <Space width="3x" />
        <Text size="sm">{t('dashboard.report')}</Text>
      </Button>
    </Flex>
  );
};
export default PDFReport;
